import { useState, useCallback } from "react";
import { EventService, isDefined } from "@perxis-auto/shared";
import { useCreditData } from "../../../features/credit/lib/useCreditData.js";
import "@perxis-auto/credit-sdk";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../features/credit/model/index.js";
import "@perxis-auto/credit-sdk/lib/internal/entities/credit/lib/formatFinancialPrograms";
import "../../../shared/config/env.js";
import { APP_EVENTS, APP_EVENT_BUTTON_IDS } from "../../../shared/config/events.js";
import "../../../shared/context/constructor.js";
import { useThisContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "../../../shared/store/config/middleware/index.js";
import "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import { selectCredit } from "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import { selectTradeIn } from "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
import "../ui/Finance.js";
import { FinanceDrawerEnum } from "../ui/Finance.types.js";
const useContainer = (item) => {
  var _a, _b;
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const eventService = EventService.getInstance();
  const vehicleItem = useThisContext();
  const [selectedDrawer, setSelectedDrawer] = useState(null);
  const { enable: isTradeInEnable } = useAppSelector(selectTradeIn);
  const { enable: isCreditEnable } = useAppSelector(selectCredit);
  const vehicleId = vehicleItem == null ? void 0 : vehicleItem.id;
  const model = (_a = vehicleItem == null ? void 0 : vehicleItem.data) == null ? void 0 : _a.model;
  const price = (_b = vehicleItem == null ? void 0 : vehicleItem.data) == null ? void 0 : _b.price;
  const creditData = useCreditData(vehicleId);
  const onDrawerClose = useCallback(() => setSelectedDrawer(null), []);
  const onCardButtonClick = useCallback(
    (drawer) => {
      setSelectedDrawer(drawer);
      switch (drawer) {
        case FinanceDrawerEnum.Credit:
          eventService.sendEvent(APP_EVENTS.ButtonClicked, {
            id: APP_EVENT_BUTTON_IDS.OPEN_CREDIT_INSTOCK
          });
          break;
        case FinanceDrawerEnum.TradeIn:
          eventService.sendEvent(APP_EVENTS.ButtonClicked, {
            id: APP_EVENT_BUTTON_IDS.OPEN_TRADE_IN_INSTOCK
          });
          break;
      }
    },
    [eventService]
  );
  const isCreditCardShow = isCreditEnable && isDefined(vehicleId) && isDefined(model) && isDefined(price) && isDefined(creditData) && isDefined(creditData.previewProgram);
  const isTradeInCardShow = isTradeInEnable;
  const isHidden = !isCreditCardShow && !isTradeInCardShow;
  return {
    ...props,
    creditData,
    vehicleItem,
    selectedDrawer,
    isCreditCardShow,
    isTradeInCardShow,
    isHidden,
    onDrawerClose,
    onCardButtonClick
  };
};
export {
  useContainer
};
